'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491 from "./presto.-Presto-Router$$anon$91.js";
import * as $j_presto$002e$002dRegister$002dDirective$002dPage$0024 from "./presto.-Register-Directive-Page$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$90() {
  this.bq4 = null;
  this.bpW = null;
  this.bpX = false;
  this.bq5 = null;
  this.bq6 = false;
  this.bq9 = null;
  this.bq2 = null;
  this.bq3 = false;
  this.bpY = null;
  this.bpZ = false;
  this.bq0 = null;
  this.bq1 = false;
  this.bq7 = false;
  this.bq8 = false;
  this.bq4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bq9 = "RegisterDirectivePage";
}
export { $c_Lpresto_PrestoRouter$$anon$90 as $c_Lpresto_PrestoRouter$$anon$90 };
$p = $c_Lpresto_PrestoRouter$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$90;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$90() {
}
export { $h_Lpresto_PrestoRouter$$anon$90 as $h_Lpresto_PrestoRouter$$anon$90 };
$h_Lpresto_PrestoRouter$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bq4;
});
$p.M = (function() {
  if ((!this.bpX)) {
    this.bpW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bpX = true;
  }
  return this.bpW;
});
$p.O = (function() {
  if ((!this.bq6)) {
    this.bq5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bq6 = true;
  }
  return this.bq5;
});
$p.D = (function() {
  return this.bq9;
});
$p.t = (function() {
  if ((!this.bq3)) {
    this.bq2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("url", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selector", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bq3 = true;
  }
  return this.bq2;
});
$p.N = (function() {
  if ((!this.bpZ)) {
    this.bpY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fi(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bpZ = true;
  }
  return this.bpY;
});
$p.Q = (function() {
  if ((!this.bq1)) {
    this.bq0 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002491.$c_Lpresto_PrestoRouter$$anon$91();
    this.bq1 = true;
  }
  return this.bq0;
});
$p.v = (function() {
  if ((!this.bq8)) {
    this.bq7 = false;
    this.bq8 = true;
  }
  return this.bq7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee576) => ((p) => \u03b4scrutinee576.cHa(p)))($j_presto$002e$002dRegister$002dDirective$002dPage$0024.$m_Lpresto_RegisterDirectivePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$90, "presto.PrestoRouter$$anon$90", ({
  P8: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$90 as $d_Lpresto_PrestoRouter$$anon$90 };
//# sourceMappingURL=presto.-Presto-Router$$anon$90.js.map
